import { reactive,computed} from 'vue'
import $ from 'jquery'
import 'jquery.cookie'
import Util from '../../lib/util'

// state
const state = reactive({
  //デバッグを表示するか
  debug:false,

  //初期処理が完了したか
  init:false,

  //現在のマップ //1:広域,2:山頂本堂中域,3:山頂本堂詳細,4:鳳凰殿中域,5:鳳凰殿詳細
  maptype:1,
  maptypeTxt:computed(()=>{return state.getMaptypeTxtByMaptype(state.maptype)}),
  getMaptypeTxtByMaptype:computed(()=>{
    return (maptype)=>{
      if(maptype == 2){
        return '山頂本堂 周辺'
      } else if(maptype == 3){
        return '山頂本堂 詳細'
      } else if(maptype == 4){
        return '西之坊鳳凰殿 周辺'
      } else if(maptype == 5){
        return '西之坊鳳凰殿 詳細'
      } else {
        return '倶利伽羅不動寺 周辺'
      }
    }
  }),

  //季節 //1:春,2:夏,3:秋,4:冬
  season:1,
  seasonDecided:true,
  seasonColor:computed(()=>{
    return (season,hotoke)=>{
      if(hotoke){
        return '#f8f2da'
      } else {
        if(season == 1){
          return '#e7f1d6'
        } else if(season == 2){
          return '#d9f2d4'
        } else if(season == 3){
          return '#f0e0d3'
        } else if(season == 4){
          return '#d8eaec'
        }
      }
      return '#ffffff'
    }
  }),

  //くりから仏モード
  hotoke:false,
  hotokeCount:computed(()=>{return state.hotokeDoneArticleIds.length}),
  hotokeCountCheck:computed(()=>{return state.hotokeCount >= 8}),
  hotokeDoneArticleIds:[],
  
  //記事
  article:{
    show:false,
    loading:false,
    notfound:false,
    name:'',
  },

  //ピンクリック時の簡易情報
  easyinfo:{
    show:false,
    mapdata:{}
  },

  //ナビ
  nav:false,

  //mapScenesのカメラ
  mapSceneCameras:{
    1:{x:0,y:0,speedX:0,speedY:0},
    2:{x:0,y:0,speedX:0,speedY:0},
    3:{x:0,y:0,speedX:0,speedY:0},
    4:{x:0,y:0,speedX:0,speedY:0},
    5:{x:0,y:0,speedX:0,speedY:0}
  },

  //雲
  kumoMotion:0,
  kumoMotionDuration:700,
  kumoMotionDelay:500,
  kumoMotionDurationLarge:500,
  kumoMotionDelayLarge:300,
  kumoMotionDurationAll:computed(()=>{return state.kumoMotionDuration + state.kumoMotionDelay}),
  kumoSize:{
    1:{width:634,height:184},
    2:{width:590,height:184},
    3:{width:498,height:184}
  },


  //マップタイプ切り替えモーション
  mapytypeMotionDuration1:700,
  mapytypeMotionDuration2:0,
  mapytypeMotionDurationAll:computed(()=>{
    // const offsetDuration = state.introMotion == 0 ? 0 : 400
    const offsetDuration = 0
    return state.mapytypeMotionDuration1 + state.mapytypeMotionDuration2 + offsetDuration}
  ),
  mapytypeMotionDelayTimeOne:35,


  //イントロ
  introMotion:1,

  //meta
  meta:{
    title:computed(()=>{
      let sub = ''
      if(state.article.show){
        if(state.article.name){
          sub = state.article.name + ' | '
        }
      } else {
        if(state.maptype == 1){
          sub = ''
        } else {
          sub = state.maptypeTxt +  ' | '
        }
      }
      return sub + 'くりからしるべ'
    })
  },

  //初回アクセスしたルーター名
  firstRouteName:'',

  //チュートリアル
  tutorial:{
    done:false,
    through:false,
    show:computed(()=>{
      return !state.tutorial.done && !state.article.show
    })
  },

  getMapSceneCameraGLobalXY:(coordinateX,coordinateY,maptype=null)=>{
    if(!maptype){
      maptype = state.maptype
    }
    const camera = state.mapSceneCameras[maptype]
    // console.log(camera.x,camera.y,coordinateX,coordinateY);
    return {
      x:Number(coordinateX) + camera.x,
      y:Number(coordinateY) + camera.y
    }
  },
})

/**
 * デバッグの初期設定
 */
function initDebug(){
  const vars = Util.getUrlVars()
  if(vars.debug == '1'){
    state.debug = true
  }
}


/**
 * 季節の初期設定
 */
function initSeason(){
  let d = new Date()
  let m = d.getMonth() + 1
  if(m >= 3 && m <= 5){
    state.season = 1
  } else if(m >= 6 && m <= 8){
    state.season = 2
  } else if(m >= 9 && m <= 11){
    state.season = 3
  } else {
    state.season = 4
  }
}

/**
 * 仏の初期設定
 */
function initHotoke(){
  let ids = getDoneArticleIds()
  if(ids.length > 0){
    state.hotokeDoneArticleIds = ids
  } else {
    state.hotokeDoneArticleIds = []
  }
}


/**
 * 仏の更新
 */
function updateHotoke(article_id){
  let ids = getDoneArticleIds()
  if(ids.length > 0){
    if(ids.indexOf(article_id) == -1){
      ids.push(article_id)
     }
     state.hotokeDoneArticleIds = ids
  } else {
    state.hotokeDoneArticleIds = [article_id]
  }
  $.cookie('done_article_ids',state.hotokeDoneArticleIds.join(","), { expires:365 * 10, path: '/' })
}

/**
 * 仏の更新
 */
 function clearHotoke(){
  state.hotokeDoneArticleIds = []
  $.cookie('done_article_ids',"", { expires:365 * 10, path: '/' })
}


/**
 * チュートリアルの初期設定
 */
function initTutorial(){
  let done_tutorial = $.cookie('done_tutorial')
  if(done_tutorial == '1'){
    state.tutorial.done = true
  } else {
    state.tutorial.done = false
    state.tutorial.through = true
  }
}

/**
 * チュートリアルの更新
 */
function updateTutorial(){
  $.cookie('done_tutorial','1', { expires:365 * 10, path: '/' })
  state.tutorial.done = true
}

/**
 * チュートリアルの更新
 */
 function clearTutorial(){
  $.cookie('done_tutorial','0', { expires:365 * 10, path: '/' })
  state.tutorial.done = false
  state.tutorial.through = true
}


/**
 * cookieに保存されている読んだ記事IDを返す
 */
function getDoneArticleIds(){
  let done_article_ids = $.cookie('done_article_ids')
  if(done_article_ids){
    let ids = done_article_ids.split(",")
    let rt = []
    ids.forEach((v)=>{
      rt.push(Number(v))
    })
    return rt
  } else {
    return []
  }
}

//=============================
//
// ローカル関数
//
//=============================

export default {
  namespaced: true,
  state,
  initDebug,
  initSeason,
  initHotoke,
  updateHotoke,
  clearHotoke,
  initTutorial,
  updateTutorial,
  clearTutorial,
}
